import { useTranslation } from "react-i18next";
import { DESCRIPTION_LANGS, type DescriptionLang } from "@hisense/shared";

/**
 * Chứng từ này in mô tả bằng tiếng gì.
 *
 * Đặt ở TỪNG CHỨNG TỪ chứ không ở sản phẩm: cùng một mã nút bán cho cả khách
 * Trung Quốc lẫn khách châu Âu, nên một cờ trên sản phẩm sẽ ép mọi khách dùng
 * chung một thứ tiếng — đổi cho khách này là đổi luôn cho khách kia.
 *
 * Lựa chọn được LƯU cùng chứng từ, không hỏi lại mỗi lần in: một tờ báo giá đã
 * gửi khách Trung Quốc thì lần in lại sau vẫn phải ra đúng thứ tiếng đó.
 */
export function PrintLanguageToggle({
  value,
  onChange,
  disabled,
}: {
  value: DescriptionLang;
  onChange: (lang: DescriptionLang) => void;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-ink-soft">{t("common.printLanguage")}</span>
      <div className="inline-flex overflow-hidden rounded-md border border-line" role="group" aria-label={t("common.printLanguage")}>
        {DESCRIPTION_LANGS.map((lang) => (
          <button
            key={lang}
            type="button"
            disabled={disabled}
            aria-pressed={value === lang}
            className={`px-2.5 py-1 text-xs ${value === lang ? "bg-brand text-white" : "bg-surface text-ink-soft hover:bg-surface-2"} disabled:opacity-50`}
            onClick={() => onChange(lang)}
          >
            {t(`common.printLanguage_${lang}`)}
          </button>
        ))}
      </div>
    </div>
  );
}
